import { Controller } from 'react-hook-form';
import { FlowStepProps } from '../../../types/addFlow.types';
import { TRIGGER_OPTIONS } from '../../../constants/flowTriggers';
import { StanDropdown } from '@/components/core-components/StanDropdown/StanDropdown';

export const TriggerSelectionStep = ({ control, errors }: FlowStepProps) => {
    return (
        <div className='mb-6 flex w-full flex-col gap-6 sm:mb-8 sm:gap-8'>
            <h3>When do you want to start your email sequence?</h3>
            <Controller
                name='selectedTrigger'
                control={control}
                render={({ field }) => {
                    const currentValue = field.value
                        ? {
                              value: field.value,
                              label: TRIGGER_OPTIONS.find(opt => opt.value === field.value)?.label || '',
                          }
                        : null;

                    return (
                        <StanDropdown
                            id='trigger-select'
                            name='selectedTrigger'
                            options={TRIGGER_OPTIONS}
                            currentValue={currentValue}
                            placeholder='Select a trigger'
                            required
                            error={!!errors.selectedTrigger}
                            hintText={errors.selectedTrigger?.message}
                            label='Trigger'
                            placement='bottom'
                            onSelect={value => field.onChange(value.value)}
                            preventDeselect
                        />
                    );
                }}
            />
        </div>
    );
};
